
  export function configuration(state = null, action) {
      return state;
}